<template>
	<div v-bl-input>
		<input type="text" v-model="value" @input="setFilter()" />
		<span class="suffix material-icons" @click="value = null; setFilter();" style="visibility: visible; margin-top: 10px;">{{ value ? 'remove_circle_outline' : '' }}</span>
	</div>
</template>

<script>
export default {
	name: 'BlListFilterSearchPhone',
	props: ['initialValue', 'metadata'],
	emits: ['blListFilterChange'],
	data() {
		return {
			value: null
		}
	},
	created() {
		this.value = this.initialValue
	},
	methods: {
		setFilter() {
			if(this.value) {
				let parsed = this.value.replaceAll(/[^0-9+]/g, '')
				this.$emit('blListFilterChange', [[this.metadata.field.name, '*=*', parsed], this.value])
			}
			else this.$emit('blListFilterChange', null)
		}
	}
}
</script>

<style scoped lang="scss">
	.suffix {
		cursor: pointer;
	}
</style>